import { setAuthToken } from './localStorage';

/**
 * GoodLoka opens the game with `http://host:port/?token=JWT` (query before `#`).
 * With createHashRouter, `useLocation().search` does not include that query string.
 */
export const getTokenFromBrowserUrl = (): string | null => {
  const pageParams = new URLSearchParams(window.location.search);
  const pageToken = pageParams.get('token');
  if (pageToken) {
    return pageToken;
  }

  const hash = window.location.hash;
  const hashQueryIndex = hash.indexOf('?');
  if (hashQueryIndex === -1) {
    return null;
  }
  const hashParams = new URLSearchParams(hash.slice(hashQueryIndex));
  return hashParams.get('token');
};

export const stripTokenFromBrowserUrl = (): void => {
  const pageParams = new URLSearchParams(window.location.search);
  if (pageParams.has('token')) {
    pageParams.delete('token');
    const search = pageParams.toString();
    const next = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;
    window.history.replaceState({}, '', next);
    return;
  }

  const hash = window.location.hash;
  const hashQueryIndex = hash.indexOf('?');
  if (hashQueryIndex === -1) {
    return;
  }
  const hashPath = hash.slice(0, hashQueryIndex);
  const hashParams = new URLSearchParams(hash.slice(hashQueryIndex));
  hashParams.delete('token');
  const rest = hashParams.toString();
  const nextHash = `${hashPath}${rest ? `?${rest}` : ''}`;
  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}${window.location.search}${nextHash}`,
  );
};

export const persistSsoTokenFromUrl = (): string | null => {
  const token = getTokenFromBrowserUrl();
  if (!token) {
    return null;
  }
  setAuthToken(token);
  stripTokenFromBrowserUrl();
  return token;
};
